exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-options i {\n\tposition: relative;\n\ttop: 3px;\n\tleft: 5px;\n}\n", ""]);

// exports
